import { Component, OnInit, Inject } from '@angular/core';
import { AccountService } from '../../../services/account.service';
import { CommonfilterService } from '../../../services/commonfilter.service';
import { SupportAccountService } from '../../../services/support/support-account.service';
import { UntypedFormGroup, UntypedFormBuilder, NgForm, Validators } from '@angular/forms';
import { __core_private_testing_placeholder__ } from '@angular/core/testing';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-verify-account-dialog',
  templateUrl: './verify-account-dialog.component.html',
  styleUrls: ['./verify-account-dialog.component.css']
})
export class VerifyAccountDialogComponent implements OnInit {

  api_error: any;
  api_success: string;
  verifyLevels: any = [];
  verifyObj: any = {};
  verify_check = { isselected: false };
  basic: any = {};
  premium: any = {};
  basicplus: any = {};
  basic_verifyForm: UntypedFormGroup;
  basicplus_verifyForm: UntypedFormGroup;
  premium_verifyForm: UntypedFormGroup;
  level: any;
  btntext = 'Verify';
  disableClass = 'btn btn-primary active';
  disableBasicClass = 'btn btn-primary active';
  show: boolean;
  basicView: boolean;
  premiumView: boolean;
  basicplusView: boolean;
  accountCompleteInfo: any;
  basicViewData: any;
  basicplusViewData: any;
  premiumViewData: any;
  verifyLevel: number;
  remainingDue = 0;
  configData: any = {};
  verificationPaymentModes: any = [];
  privateNoteBasic = '';
  doneBy = '';
  privateNoteBasicplus = '';
  basicPlusdoneBy = '';
  privateNoteAdvanced = '';
  advanceddoneBy = '';

  constructor(
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private accountService: AccountService,
    private commonService: CommonfilterService,
    private supportAccountService: SupportAccountService,
    private formbuilder: UntypedFormBuilder) {
    this.commonService.getConfigData()
      .subscribe(res => {
        this.configData = res;
        this.verificationPaymentModes = this.configData.verificationPaymentModeDetails;
      });
  }


  basicformErrors = {
    'verifiedOn': '',
    'verifyLink': '',
    'verifiedNote': '',
    'verifiedBy': ''

  };
  basicplusformErrors = {
    'verifiedOn': '',
    'verifyLink': '',
    'verifiedNote': '',
    'verifiedBy': ''

  };
 advancedformErrors = {
    'verifiedOn': '',
    'verifyLink': '',
    'verifiedNote': '',
    'verifiedBy': ''

  };
  ValidationMessages = {
    'verifiedOn': {
      'required': 'Verified On  is Required',
    },
    'verifyLink': {
      'required': 'Verification Link  is Required'
    },
    'verifiedNote': {
      'required': 'Verification Note  is Required',

    },
    'verifiedBy': {
      'required': 'Verified By  is Required',
    },
  };

  ngOnInit() {

    switch (this.data.account.account.verifyLevel) {
      case 'BASIC':
        this.disableClass = 'btn btn-primary active';
        this.btntext = 'Update and Verify';
        this.basicView = true;
        this.basicplusView = false;
        this.premiumView = false;
        this.verifyLevel = 1;
        break;

      case 'BASIC_PLUS':
        this.disableClass = 'btn btn-primary disabled';
        this.disableBasicClass = 'btn btn-primary active';
        this.btntext = 'Verify/Update';
        this.basicView = true;
        this.basicplusView = true;
        this.premiumView = false;
        this.verifyLevel = 2;
        break;
      case 'ADVANCED':
        this.disableClass = 'btn btn-primary disabled';
        this.disableBasicClass = 'btn btn-primary disabled';
        this.btntext = 'Verify/Update';
        this.basicView = true;
        this.basicplusView = true;
        this.premiumView = true;
        this.verifyLevel = 3;
        break;
      case 'NONE':
        this.disableBasicClass = 'btn btn-primary active';
        this.disableClass = 'btn btn-primary active';
        this.btntext = 'Verify';
        this.basicView = false;
        this.basicplusView = false;
        this.premiumView = false;
        this.verifyLevel = 0;
        break;
    }

    this.createForm();

  }
  createForm() {
    this.basic_verifyForm = this.formbuilder.group({
      verifiedOn: ['', [Validators.required]],
      verifyLink: ['', [Validators.required]],
      verifiedNote: ['', [Validators.required]],
      verifiedBy: ['', [Validators.required]],
      totalCharged: '',
      discountApplied: '',
      totalCollected: '',
      paymentMode: 'None',
      privateNote: '',
      updatedBy: ''
    });
    this.basicplus_verifyForm = this.formbuilder.group({
      verifiedOn: '',
      verifiedNote: '',
      verifiedBy: '',
      totalCharged: '',
      discountApplied: '',
      totalCollected: '',
      paymentMode: 'None',
      privateNote: '',
      updatedBy: ''

    });
    this.premium_verifyForm = this.formbuilder.group({
      verifiedOn: '',
      verifiedNote: '',
      verifiedBy: '',
      totalCharged: '',
      discountApplied: '',
      totalCollected: '',
      paymentMode: 'None',
      privateNote: '',
      updatedBy: ''

    });
    // const today = new Date().toISOString().split('T')[0];
    // document.getElementsByName('verifiedOn')[0].setAttribute('max', today);
    if (this.data.type === 'edit') {
      this.updateForm();
    }
  }
  updatebasicInfo() {
    this.basicView = false;
    this.basic_verifyForm.get('totalCharged').disable();
    this.basic_verifyForm.get('discountApplied').disable();
    this.basic_verifyForm.get('totalCollected').disable();
    this.basic_verifyForm.get('paymentMode').disable();
    this.basic_verifyForm.get('privateNote').disable();
    this.basic_verifyForm.get('updatedBy').disable();

    if (this.verifyLevel === 2) {
      this.basicplusView = true;
    } else if (this.verifyLevel === 3) {
      this.premiumView = true;
      this.basicplusView = true;
    }
    this.btntext = 'Update';
    this.disableBasicClass = 'btn btn-primary active';
  }


  updatebasicPlusInfo() {
    this.basicView = true;
    this.basicplusView = false;
    this.basicplus_verifyForm.get('totalCharged').disable();
    this.basicplus_verifyForm.get('discountApplied').disable();
    this.basicplus_verifyForm.get('totalCollected').disable();
    this.basicplus_verifyForm.get('paymentMode').disable();
    this.basicplus_verifyForm.get('privateNote').disable();
    this.basicplus_verifyForm.get('updatedBy').disable();
    if (this.verifyLevel === 3) {
      this.premiumView = true;
      this.btntext = 'Update';
    } else {
      this.btntext = 'Verify';
    }
    this.disableBasicClass = 'btn btn-primary active';
  }
  updatepremiumInfo() {
    this.basicView = true;
    this.premium_verifyForm.get('totalCharged').disable();
    this.premium_verifyForm.get('discountApplied').disable();
    this.premium_verifyForm.get('totalCollected').disable();
    this.premium_verifyForm.get('paymentMode').disable();
    this.premium_verifyForm.get('privateNote').disable();
    this.premium_verifyForm.get('updatedBy').disable();
    this.basicplusView = true;
    this.premiumView = false;
    this.btntext = 'Update';
    this.disableBasicClass = 'btn btn-primary active';
  }
  updateForm() {

    this.accountCompleteInfo = this.data.account.accountVerificationDetails;
    for (let i = 0; i < this.accountCompleteInfo.length; i++) {

      switch (this.accountCompleteInfo[i].verifyLevel) {
        case 'BASIC':
          this.basicViewData = this.accountCompleteInfo[i];
          if (this.accountCompleteInfo[i].privateNote) {
            const privateNotesBasic = JSON.parse(this.accountCompleteInfo[i].privateNote);
            privateNotesBasic.privateNote.forEach(note => {
              this.privateNoteBasic = note.note;
              this.doneBy = note.noteBy;
            });
     
          }

          this.basic_verifyForm.setValue({
            'verifyLink': this.accountCompleteInfo[i].verifyLink || 'Nil',
            'verifiedNote': this.accountCompleteInfo[i].verifiedNote || 'Nil',
            'totalCharged': this.accountCompleteInfo[i].totalCharged || 'Nil',
            'discountApplied': this.accountCompleteInfo[i].discountApplied || 'Nil',
            'totalCollected': this.accountCompleteInfo[i].totalCollected || 'Nil',
            'paymentMode': this.accountCompleteInfo[i].paymentMode || 'Nil',
            'privateNote': this.privateNoteBasic || 'Nil',
            'verifiedBy': this.accountCompleteInfo[i].verifiedBy || 'Nil',
            'updatedBy': this.doneBy || 'Nil',
            'verifiedOn': this.accountCompleteInfo[i].verifiedOn || 'Nil'


          });
          this.remainingDue = this.accountCompleteInfo[i].dueAmount;
          break;
        case 'BASIC_PLUS':
          this.basicplusViewData = this.accountCompleteInfo[i];
          if (this.accountCompleteInfo[i].privateNote) {
            const privateNotesBasicplus = JSON.parse(this.accountCompleteInfo[i].privateNote);
            privateNotesBasicplus.privateNote.forEach(note => {
              this.privateNoteBasicplus = note.note;
              this.basicPlusdoneBy = note.noteBy;

            });
          }

          this.basicplus_verifyForm.setValue({
            'verifiedNote': this.accountCompleteInfo[i].verifiedNote || 'Nil',
            'totalCharged': this.accountCompleteInfo[i].totalCharged || 'Nil',
            'discountApplied': this.accountCompleteInfo[i].discountApplied || 'Nil',
            'totalCollected': this.accountCompleteInfo[i].totalCollected || 'Nil',
            'paymentMode': this.accountCompleteInfo[i].paymentMode || 'Nil',
            'privateNote': this.privateNoteBasicplus || 'Nil',
            'verifiedBy': this.accountCompleteInfo[i].verifiedBy || 'Nil',
            'updatedBy': this.basicPlusdoneBy || 'Nil',
            'verifiedOn': this.accountCompleteInfo[i].verifiedOn || 'Nil'
          });
          this.remainingDue = this.accountCompleteInfo[i].dueAmount;
          break;
        case 'ADVANCED':
          this.premiumViewData = this.accountCompleteInfo[i];
          if (this.accountCompleteInfo[i].privateNote) {
            const privateNotesAdvanced = JSON.parse(this.accountCompleteInfo[i].privateNote);
            privateNotesAdvanced.privateNote.forEach(note => {
              this.privateNoteAdvanced = note.note;
              this.advanceddoneBy = note.noteBy;

            });
          }

          this.premium_verifyForm.setValue({
            'verifiedNote': this.accountCompleteInfo[i].verifiedNote || 'Nil',
            'totalCharged': this.accountCompleteInfo[i].totalCharged || 'Nil',
            'discountApplied': this.accountCompleteInfo[i].discountApplied || 'Nil',
            'totalCollected': this.accountCompleteInfo[i].totalCollected || 'Nil',
            'paymentMode': this.accountCompleteInfo[i].paymentMode || 'Nil',
            'privateNote': this.privateNoteAdvanced || 'Nil',
            'verifiedBy': this.accountCompleteInfo[i].verifiedBy || 'Nil',
            'updatedBy': this.advanceddoneBy || 'Nil',
            'verifiedOn': this.accountCompleteInfo[i].verifiedOn || 'Nil'
          });
          this.remainingDue = this.accountCompleteInfo[i].dueAmount;
          break;
      }

    }


  }

  public closeDialog() {
    this.dialogRef.close();
  }
  basicVerification(form: NgForm) {
   // this.basic_verifyForm.get('updatedBy').enable();
    this.api_success = '';
    this.api_error = '';
    this.basic = form.value;
    this.basic.accountId = this.data.account.account.id;
    this.basic.verifiedLevel = 'BASIC';
    this.supportAccountService.basicVerify(this.basic)
      .subscribe(

        data => {
         // this.basic_verifyForm.get('updatedBy').disable();
          if (data === true) {
            this.api_success = ' Updated Successfully';
          } else {
            this.api_success = ' Basic Verification Successful';
          }
          setTimeout(() => {
            this.dialogRef.close();
            this.api_success = '';
          }, 2000);
        },
        (error) => {
         // this.basic_verifyForm.get('updatedBy').disable();
          this.api_error = error.error;
          setTimeout(() => {

            this.api_error = '';
          }, 2000);
        }
      );

  }

  basicplusVerification(form: NgForm) {
    // this.basicplus_verifyForm.get('updatedBy').enable();
    this.api_success = '';
    this.api_error = '';
    this.basicplus = form.value;
    this.basicplus.accountId = this.data.account.account.id;
    this.basicplus.verifiedLevel = 'BASIC_PLUS';

    this.supportAccountService.basicplusVerify(this.basicplus)
      .subscribe(

        data => {
         // this.basicplus_verifyForm.get('updatedBy').disable();
          if (data === true) {
            this.api_success = 'Updated Successfully';
          } else {
            this.api_success = 'Basic Plus verification Successful';
          }
          setTimeout(() => {
            this.dialogRef.close('reloadlist');
          }, 2000);
        },
        (error) => {
         // this.basicplus_verifyForm.get('updatedBy').disable();
          this.api_error = error.error;
        }
      );

  }


  premiumVerification(form: NgForm) {
   // this.premium_verifyForm.get('updatedBy').enable();
    this.api_success = '';
    this.api_error = '';
    this.premium = form.value;
    this.premium.accountId = this.data.account.account.id;

    this.premium.verifiedLevel = 'ADVANCED';
    this.supportAccountService.premiumVerify(this.premium)
      .subscribe(

        data => {
        //  this.premium_verifyForm.get('updatedBy').disable();
          if (data === true) {
            this.api_success = 'Updated Successfully';
          } else {
            this.api_success = 'Advanced Verification Successful';
          }
          setTimeout(() => {
            this.dialogRef.close('reloadlist');
          }, 2000);
        },
        (error) => {
          // this.premium_verifyForm.get('updatedBy').disable();
          this.api_error = error.error;
        }
      );

  }
}
